const contractsCfg = {
  vaultAddress: "0x0f71e11B7688D74a4F0876F4a6FD196c2D9cD6EC",
  baseTokenBalance: 3244.942,
  quoteTokenBalance: 0,
  proxies: [
    {
      id: 0,
      address: "0x25446d5F716e382c02a86aF07D959a908F5687dF",
      baseTokenBalance: 0,
      quoteTokenBalance: 204.4,
    },
    {
      id: 1,
      address: "0x8c34584cBc82DB718D4977877CD6Bd10bA779244",
      baseTokenBalance: 0,
      quoteTokenBalance: 65.41,
    },
  ],
};

export default contractsCfg;
